import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { PANGU_AUTH_ID_MAP } from './constant/common';

const Login = lazy(async () => await import('pages/Login'));
const NavigateComp = lazy(async () => await import('pages/Navigate'));
const Exception = lazy(async () => await import('pages/Exception'));
const Index = lazy(async () => await import('pages/DataBoard/index'));
const MyData = lazy(async () => await import('pages/DataBoard/myData'));
const CaiBlindReview = lazy(async () => await import('pages/Review/caiBlindReview'));
const TTSBlindReview = lazy(async () => await import('pages/Review/ttsBlindReview'));
const CorpusTTSReview = lazy(async () => await import('pages/Review/corpusTTSReview'));
const ComparedTTSReview = lazy(async () => await import('pages/Review/comparedTTSReview'));
const ImgModelReview = lazy(async () => await import('pages/Review/ImgModelReview'));
const H5BotChatReview = lazy(async () => await import('pages/Review/h5BotChatReview'));
const ImgReview = lazy(async () => await import('pages/Review/ImgReview'));
const AccountApprove = lazy(async () => await import('pages/Account/approve'));
const ProjectList = lazy(async () => await import('pages/CorpusUpgraded/project'));
const TaskList = lazy(async () => await import('pages/CorpusUpgraded/task'));
const TemplateList = lazy(async () => await import('pages/CorpusUpgraded/template'));
const QaList = lazy(async () => await import('pages/CorpusUpgraded/qa'));
const ImagePadding = lazy(async () => await import('pages/ImageManage/padding'));
const CorpusSetManage = lazy(async () => await import('pages/PipeLine/CorpusSetManage/index'));
const CorpusTaskManage = lazy(async () => await import('pages/PipeLine/CorpusTaskManage/index'));
const UploadCorpusManage = lazy(async () => await import('pages/PipeLine/UploadCorpusManage/index'));
const CorpusProcessProjectManage = lazy(async () => await import('pages/PipeLine/ProjectManage/index'));
const CorpusProcessProjectDetail = lazy(async () => await import('pages/PipeLine/ProjectManage/ProjectDetail/index'));
const AnnotationTemplateManage = lazy(async () => await import('pages/PipeLine/AnnotationTemplateManage/index'));
const ModuleProjectManage = lazy(async () => await import('pages/PipeLine/ModuleProjectManage/index'));
const ModuleProjectDetail = lazy(
  async () => await import('pages/PipeLine/ModuleProjectManage/ModuleProjectDetail/index'),
);

// 评测管理页面
const EvaluateSampleManage = lazy(async () => await import('pages/Evaluate/SampleManage/index'));
const EvaluateSampleSetManage = lazy(async () => await import('pages/Evaluate/SampleSetManage/index'));
const EvaluateTaskManage = lazy(async () => await import('pages/Evaluate/TaskManage/index'));
const EvaluateDimensionManage = lazy(async () => await import('pages/Evaluate/DimensionManage/index'));
const EvaluateOnlineSampleManage = lazy(async () => await import('pages/Evaluate/OnlineSampleManage/index'));
const EvaluatePromptManage = lazy(async () => await import('pages/Evaluate/PromptManage/index'));

const ROUTER_CONFIG = [
  {
    path: '/exception-403',
    element: <Exception type='403' />,
    meta: {
      white: true,
    },
  },
  {
    path: '/exception-404',
    element: <Exception type='404' />,
    meta: {
      white: true,
    },
  },
  {
    path: '/',
    element: <NavigateComp />,
    meta: {
      white: false,
    },
  },
  {
    path: '/login',
    element: <Login />,
    meta: {
      white: true,
    },
  },
  {
    path: '/databoard',
    element: <Index />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.view_all_sys_data],
  },
  {
    path: '/databoard/mydata',
    element: <MyData />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.view_all_sys_data],
  },
  {
    path: '/account/approve',
    element: <AccountApprove />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.approve_auth],
  },
  {
    path: '/corpus_upgraded/project',
    element: <ProjectList />,
    meta: {
      white: false,
    },
    checkAuth: [
      PANGU_AUTH_ID_MAP.create_project,
      PANGU_AUTH_ID_MAP.manage_project,
      PANGU_AUTH_ID_MAP.mark,
      PANGU_AUTH_ID_MAP.review,
      PANGU_AUTH_ID_MAP.sample,
      PANGU_AUTH_ID_MAP.check,
    ],
  },
  {
    path: '/corpus_upgraded/task',
    element: <TaskList />,
    meta: {
      white: false,
    },
    checkAuth: [
      PANGU_AUTH_ID_MAP.create_project,
      PANGU_AUTH_ID_MAP.manage_project,
      PANGU_AUTH_ID_MAP.mark,
      PANGU_AUTH_ID_MAP.review,
      PANGU_AUTH_ID_MAP.sample,
      PANGU_AUTH_ID_MAP.check,
    ],
  },
  {
    path: '/corpus_upgraded/template',
    element: <TemplateList />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.template_manage],
  },
  {
    path: '/corpus_upgraded/qa',
    element: <QaList />,
    meta: {
      white: false,
    },
    checkAuth: [
      PANGU_AUTH_ID_MAP.create_project,
      PANGU_AUTH_ID_MAP.manage_project,
      PANGU_AUTH_ID_MAP.mark,
      PANGU_AUTH_ID_MAP.review,
      PANGU_AUTH_ID_MAP.sample,
      PANGU_AUTH_ID_MAP.check,
    ],
  },
  {
    path: '/review/cai_blind_review',
    element: <CaiBlindReview />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.cai_blind_review],
  },
  {
    path: '/review/tts_review',
    element: <TTSBlindReview />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.tts_blind_review],
  },
  {
    path: '/review/corpus_tts_review',
    element: <CorpusTTSReview />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.corpus_tts_blind_review, PANGU_AUTH_ID_MAP.corpus_tts_blind_review_manage],
  },
  {
    path: '/review/compared_tts_review',
    element: <ComparedTTSReview />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.corpus_tts_compared_review, PANGU_AUTH_ID_MAP.corpus_tts_compared_review_manage],
  },
  {
    path: '/review/img_model_review',
    element: <ImgModelReview />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.corpus_img_model_review, PANGU_AUTH_ID_MAP.corpus_img_model_review_manage],
  },
  {
    path: '/review/h5_bot_chat_review',
    element: <H5BotChatReview />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.h5_eval_review, PANGU_AUTH_ID_MAP.h5_eval_review_manage],
  },
  {
    path: '/review/img_review',
    element: <ImgReview />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.img_blind_review, PANGU_AUTH_ID_MAP.img_blind_review_manage],
  },
  {
    path: '/pipeline/crawl',
    element: <CorpusTaskManage />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
  },
  {
    path: '/pipeline/local-upload',
    element: <UploadCorpusManage />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
  },
  {
    path: '/pipeline/machine-common',
    element: <CorpusTaskManage />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
  },
  {
    path: '/pipeline/corpus-cleaning',
    element: <CorpusTaskManage />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
  },
  {
    path: '/pipeline/machine-modification',
    element: <CorpusTaskManage />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
  },
  {
    path: '/pipeline/corpus-set-manage',
    element: <CorpusSetManage />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_manage],
  },
  {
    path: '/pipeline/project-manage',
    element: <CorpusProcessProjectManage />,
    meta: {
      white: false,
    },
    checkAuth: [
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_manage,
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_mark,
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_review,
    ],
  },
  {
    path: '/pipeline/project-manage/detail',
    element: <CorpusProcessProjectDetail />,
    meta: {
      white: false,
    },
    checkAuth: [
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_manage,
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_mark,
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_review,
    ],
  },
  {
    path: '/pipeline/annotation-template',
    element: <AnnotationTemplateManage />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.corpus_pipeline_project_manage],
  },
  {
    path: '/pipeline/module-project',
    element: <ModuleProjectManage />,
    meta: {
      white: false,
    },
    checkAuth: [
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_manage,
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_mark,
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_review,
    ],
  },
  {
    path: '/pipeline/module-project/detail',
    element: <ModuleProjectDetail />,
    meta: {
      white: false,
    },
    checkAuth: [
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_manage,
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_mark,
      PANGU_AUTH_ID_MAP.corpus_pipeline_project_review,
    ],
  },
  {
    path: 'image_manage/padding',
    element: <ImagePadding />,
    meta: {
      white: false,
    },
    checkAuth: [PANGU_AUTH_ID_MAP.image_manage],
  },
  // 评测管理路由
  {
    path: '/evaluate/sample-manage',
    element: <EvaluateSampleManage />,
    checkAuth: [PANGU_AUTH_ID_MAP.pipeline_evaluate_manage],
    meta: {
      white: false,
    },
  },
  {
    path: '/evaluate/sample-set-manage',
    element: <EvaluateSampleSetManage />,
    checkAuth: [PANGU_AUTH_ID_MAP.pipeline_evaluate_manage],
    meta: {
      white: false,
    },
  },
  {
    path: '/evaluate/task-manage',
    element: <EvaluateTaskManage />,
    checkAuth: [PANGU_AUTH_ID_MAP.pipeline_evaluate, PANGU_AUTH_ID_MAP.pipeline_evaluate_manage],
    meta: {
      white: false,
    },
  },
  {
    path: '/evaluate/dimension-manage',
    element: <EvaluateDimensionManage />,
    checkAuth: [PANGU_AUTH_ID_MAP.pipeline_evaluate_manage],
    meta: {
      white: false,
    },
  },
  {
    path: '/evaluate/online-sample-manage',
    element: <EvaluateOnlineSampleManage />,
    checkAuth: [PANGU_AUTH_ID_MAP.pipeline_evaluate_manage],
    meta: {
      white: false,
    },
  },
  {
    path: '/evaluate/prompt-manage',
    element: <EvaluatePromptManage />,
    checkAuth: [PANGU_AUTH_ID_MAP.pipeline_evaluate_manage],
    meta: {
      white: false,
    },
  },
  {
    path: '*',
    element: <Navigate to='/exception-404' />,
    meta: {
      white: true,
    },
  },
];

export default ROUTER_CONFIG;
